export function isEvoError(e) {
    return e !== null && typeof e === "object" && "error_code" in e;
}
//# sourceMappingURL=isEvoError.guard.js.map